/**
 * navigation/useReloadOnFocus.ts
 * Run a loader every time the screen gains focus (initial mount + every
 * revisit). React Navigation keeps screens mounted, so a plain mount-effect
 * would only fetch once and show stale data after you navigate away and back
 * (e.g. a newly created item type not appearing). This restores the old
 * router's "refetch on every visit" behaviour.
 *
 * Pass a STABLE loader (wrap it in useCallback) to avoid re-subscribing.
 */
import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';

export function useReloadOnFocus(load: () => void): void {
  useFocusEffect(
    useCallback(() => {
      load();
    }, [load]),
  );
}
